// extracted by mini-css-extract-plugin
export default {"container":"GetRecipe_container__IVPty","subContainer":"GetRecipe_subContainer__Bp25t"};